import { ErrorDefault, ErrorMustBeMember } from './Errors.ts';
import { HTTPStatus } from './ErrorEnums.ts';
import { getNestedTranslation } from '@colonist/i18n';
function createErrorAndPurchaseMembershipPrompt(errorMessage) {
    return getNestedTranslation({
        key: 'strings:popups.errors.replay.errorAndMembershipPrompt'
    }, {
        errorMessage: errorMessage,
        membershipPrompt: {
            key: 'strings:popups.errors.replay.storePurchaseMembershipPrompt'
        }
    });
}
function createErrorAndUpgradeMembershipPrompt(errorMessage) {
    return getNestedTranslation({
        key: 'strings:popups.errors.replay.errorAndMembershipPrompt'
    }, {
        errorMessage: errorMessage,
        membershipPrompt: {
            key: 'strings:popups.errors.replay.storeUpgradeMembershipPrompt'
        }
    });
}
(function(ErrorReplay) {
    class InvalidPlayerColor extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = {
                key: 'strings:popups.errors.replay.invalidPlayerColor'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.InvalidPlayerColor = InvalidPlayerColor;
    class InvalidGameId extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = {
                key: 'strings:popups.errors.replay.invalidGameId'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.InvalidGameId = InvalidGameId;
    class InvalidUrlSlug extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = {
                key: 'strings:popups.errors.replay.invalidUrlSlug'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.InvalidUrlSlug = InvalidUrlSlug;
    class GameNotFound extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = {
                key: 'strings:popups.errors.replay.gameNotFound'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.GameNotFound = GameNotFound;
    class UserNotInGame extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = {
                key: 'strings:popups.errors.replay.userNotInGame'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.UserNotInGame = UserNotInGame;
    class NoMembershipTryingToCreateReplayLink extends ErrorMustBeMember {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = createErrorAndPurchaseMembershipPrompt({
                key: 'strings:popups.errors.replay.noMembershipTryingToCreateReplayLink'
            });
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.NoMembershipTryingToCreateReplayLink = NoMembershipTryingToCreateReplayLink;
    class NoMembershipTryingToWatchOwnReplay extends ErrorMustBeMember {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = createErrorAndPurchaseMembershipPrompt({
                key: 'strings:popups.errors.replay.noMembershipTryingToWatchOwnReplay'
            });
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.NoMembershipTryingToWatchOwnReplay = NoMembershipTryingToWatchOwnReplay;
    class NoMembershipTryingToWatchAnotherPlayerReplay extends ErrorMustBeMember {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = createErrorAndPurchaseMembershipPrompt({
                key: 'strings:popups.errors.replay.noMembershipTryingToWatchAnotherPlayerReplay'
            });
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.NoMembershipTryingToWatchAnotherPlayerReplay = NoMembershipTryingToWatchAnotherPlayerReplay;
    class NoMembershipTryingToChangeReplayPerspective extends ErrorMustBeMember {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = createErrorAndPurchaseMembershipPrompt({
                key: 'strings:popups.errors.replay.noMembershipTryingToChangeReplayPerspective'
            });
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.NoMembershipTryingToChangeReplayPerspective = NoMembershipTryingToChangeReplayPerspective;
    class InvalidMembershipTryingToWatchAnotherPlayerReplay extends ErrorMustBeMember {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = createErrorAndPurchaseMembershipPrompt({
                key: 'strings:popups.errors.replay.invalidMembershipTryingToWatchAnotherPlayerReplay'
            });
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.InvalidMembershipTryingToWatchAnotherPlayerReplay = InvalidMembershipTryingToWatchAnotherPlayerReplay;
    class PlusMembershipReplayLimitReached extends ErrorMustBeMember {
        constructor(limit){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = createErrorAndUpgradeMembershipPrompt({
                key: 'strings:popups.errors.replay.plusMembershipLimitReach',
                options: {
                    limit: limit
                }
            });
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.PlusMembershipReplayLimitReached = PlusMembershipReplayLimitReached;
    class InvalidMembership extends ErrorMustBeMember {
        constructor(){
            const title = {
                key: 'strings:popups.errors.replay.title'
            };
            const message = createErrorAndUpgradeMembershipPrompt({
                key: 'strings:popups.errors.replay.invalidMembership'
            });
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorReplay.InvalidMembership = InvalidMembership;
})(ErrorReplay || (ErrorReplay = {}));
export var ErrorReplay;
